module.exports = __webpack_public_path__ + "static/media/Group1.54cc635c.svg";